<div
   class="queue-members-view"
   [class.queue-members-view-horizontal]="displayMode === 'queues' || displayMode === 'queue-calls'"
   [class.queue-members-view-queue-agents]="displayMode === 'queues'"
   [class.queue-members-view-queue-calls]="displayMode === 'queue-calls'"
   [class.queue-members-view-wrapped-lanes]="isWrappedSwimlaneLayout"
>
   <div class="list-options-bar queue-members-filter-bar">
      <div class="queue-members-toggle-row">
         @if (isSwimlaneWrapAvailable) {
         <mat-slide-toggle
            class="slide-toggle queue-members-group-toggle"
            color="primary"
            [checked]="wrapSwimlanes"
            (change)="onWrapSwimlanesChange($event.checked)"
            >Wrap Queues</mat-slide-toggle
         >
         } @if (displayMode === 'agents') {
         <mat-slide-toggle
            class="slide-toggle queue-members-group-toggle"
            color="primary"
            [checked]="groupMembersByQueue"
            (change)="onGroupMembersByQueueChange($event.checked)"
            >Group by Queue</mat-slide-toggle
         >
         } @if (displayMode === 'agents' || displayMode === 'queues') {
         <mat-slide-toggle
            class="slide-toggle queue-members-group-toggle"
            color="primary"
            [checked]="showLoggedOutAgents"
            (change)="onShowLoggedOutAgentsChange($event.checked)"
            >Only Show Logged Out Agents</mat-slide-toggle
         >
         } @if (displayMode === 'queue-calls') {
         <mat-slide-toggle
            class="slide-toggle queue-members-group-toggle"
            color="primary"
            [checked]="includeActiveCalls"
            (change)="onIncludeActiveCallsChange($event.checked)"
            >Include Connected Calls</mat-slide-toggle
         >
         } @if (displayMode === 'queue-calls') {
         <mat-slide-toggle
            class="slide-toggle queue-members-group-toggle"
            color="primary"
            [checked]="showEmptyQueues"
            (change)="onShowEmptyQueuesChange($event.checked)"
            >Show Queues with No Agents</mat-slide-toggle
         >
         }
      </div>
   </div>

   @if (!hasVisibleQueueMembers) {
   <div class="queue-members-empty">
      {{
         displayMode === 'queue-calls'
            ? 'No active queue calls available for the selected queues.'
            : displayMode === 'queues'
            ? 'No queue members available for the selected queues.'
            : 'No logged in queue members.'
      }}
   </div>
   } @if (displayMode === 'agents' && !groupMembersByQueue && hasVisibleQueueMembers) {
   <div class="queue-member-padding">
      <ktd-grid
         class="queue-members-grid-layout"
         [trackById]="trackGridLayoutItem"
         [cols]="queueMemberGridColumns"
         [gap]="queueMemberGridGap"
         [rowHeight]="queueMemberGridRowHeight"
         [layout]="memberGridLayout"
      >
         @for (item of memberGridItems; track trackGridItem($index, item)) {
         <ktd-grid-item class="queue-member-grid-item" [id]="item.id" [draggable]="false" [resizable]="false">
            <div
               class="queue-member-tile"
               [attr.data-member-cache-key]="item.cacheKey"
               [ngClass]="getVisualStateClass(getMemberVisualState(item.member))"
            >
               <ndt-tile-view [tileConfig]="getMemberTileConfig(item)" [canRefresh]="false">
                  <p tileheadername>
                     @if (item.member.agentExtensionId != null) {
                     <a
                        class="queue-member-tile-header-link"
                        [routerLink]="getQueueExtensionLink(item.member.agentExtensionId)"
                     >
                        {{ getAgentDisplay(item.member.agentName, item.member.agentNumber) }}
                     </a>
                     } @else {
                     {{ getAgentDisplay(item.member.agentName, item.member.agentNumber) }}
                     }
                  </p>

                  <div tileInfo class="queue-member-tile-body">
                     <div class="queue-member-tile-meta">
                        <span class="queue-member-status-pill">
                           {{
                              getStatusLabel(
                                 item.member.agentStatus,
                                 item.member.endWrapUpTime,
                                 isMemberOnThePhone(item.member)
                              )
                           }}
                        </span>
                     </div>

                     <div class="queue-member-queue-list">
                        @for (queue of item.member.queues; track trackQueue($index, queue)) {
                        <a
                           class="queue-member-queue-pill"
                           [class.queue-member-queue-pill-on-phone]="isQueueCallActive(queue)"
                           [routerLink]="getQueueExtensionLink(queue.queueExtensionId)"
                        >
                           <span [matTooltip]="getQueueDisplay(queue.queueNumber, queue.queueName)">{{
                              getQueueDisplay(queue.queueNumber, queue.queueName)
                           }}</span>
                           @if (isQueuePhoneIconVisible(queue)) {
                           <mat-icon class="queue-member-phone-icon" [matTooltip]="getQueuePhoneIconTooltip(queue)">
                              phone_in_talk
                           </mat-icon>
                           }
                        </a>
                        }
                     </div>
                  </div>
               </ndt-tile-view>
            </div>
         </ktd-grid-item>
         }
      </ktd-grid>
   </div>
   } @if (displayMode === 'queues' && hasVisibleQueueMembers) {
   <div class="queue-members-horizontal-scroll">
      <div class="queue-members-horizontal-track">
         @for (item of queueGridItems; track trackGridItem($index, item)) {
         <div
            class="queue-member-horizontal-lane queue-member-horizontal-lane-queue"
            [attr.data-queue-lane-id]="item.id"
         >
            <div
               class="queue-member-tile queue-member-tile-neutral queue-member-tile-lane"
               [attr.data-queue-cache-key]="item.cacheKey"
            >
               <ndt-tile-view [tileConfig]="getQueueTileConfig(item)" [canRefresh]="false">
                  <p tileheadername>
                     <a
                        class="queue-member-tile-header-link"
                        [routerLink]="getQueueExtensionLink(item.queue.queueExtensionId)"
                     >
                        {{ getQueueDisplay(item.queue.queueNumber, item.queue.queueName) }}
                     </a>
                  </p>

                  <div tileInfo class="queue-member-tile-body queue-member-tile-body-lane">
                     <div class="queue-member-tile-meta">
                        <span
                           class="queue-member-status-pill queue-member-stat-pill"
                           [matTooltip]="getQueueCallStatTooltip(getQueueCallsForQueue(item.queue.queueExtensionId))"
                           matTooltipClass="queue-member-stat-tooltip"
                        >
                           <mat-icon class="queue-member-stat-pill-icon">phone_in_talk</mat-icon>
                           <span>{{ getQueueCallStatLabel(getQueueCallsForQueue(item.queue.queueExtensionId)) }}</span>
                        </span>
                        <span
                           class="queue-member-status-pill queue-member-stat-pill"
                           [matTooltip]="getQueueAgentStatTooltip(item.queue.queueExtensionId)"
                           matTooltipClass="queue-member-stat-tooltip"
                        >
                           <mat-icon class="queue-member-stat-pill-icon">support_agent</mat-icon>
                           <span>{{ getQueueAgentStatLabel(item.queue.queueExtensionId) }}</span>
                        </span>
                     </div>

                     <div
                        class="queue-member-agent-list queue-member-lane-scroll-region queue-member-agent-scroll-region"
                     >
                        @for (agent of item.queue.agents; track trackQueueAgent($index, agent)) { @if
                        (agent.agentExtensionId != null) {
                        <a
                           class="queue-member-agent-pill queue-member-agent-pill-link"
                           [ngClass]="[
                              getVisualStateClass(getQueueAgentVisualState(agent)),
                              isQueueAgentAvailable(agent) ? 'queue-member-agent-pill-plain' : ''
                           ]"
                           [routerLink]="getQueueExtensionLink(agent.agentExtensionId)"
                        >
                           <ng-container
                              *ngTemplateOutlet="queueAgentPillContent; context: { agent: agent }"
                           ></ng-container>
                        </a>
                        } @else {
                        <div
                           class="queue-member-agent-pill"
                           [ngClass]="[
                              getVisualStateClass(getQueueAgentVisualState(agent)),
                              isQueueAgentAvailable(agent) ? 'queue-member-agent-pill-plain' : ''
                           ]"
                        >
                           <ng-container
                              *ngTemplateOutlet="queueAgentPillContent; context: { agent: agent }"
                           ></ng-container>
                        </div>
                        } }
                     </div>

                     <ng-template #queueAgentPillContent let-agent="agent">
                        <span class="queue-member-agent-pill-copy">
                           <span
                              class="queue-member-agent-pill-name"
                              [matTooltip]="getAgentDisplay(agent.agentName, agent.agentNumber)"
                           >
                              {{ getAgentDisplay(agent.agentName, agent.agentNumber) }}
                           </span>
                           @if (getQueueAgentSecondaryQueueLabel(agent); as queueAgentSecondaryQueueLabel) {
                           <span class="queue-member-agent-pill-secondary" [matTooltip]="queueAgentSecondaryQueueLabel">
                              {{ queueAgentSecondaryQueueLabel }}
                           </span>
                           }
                        </span>
                        @if (!isQueueAgentAvailable(agent) || isQueueAgentActive(agent)) {
                        <span
                           class="queue-member-agent-pill-meta"
                           [class.queue-member-agent-pill-meta-clickable]="canOpenQueueAgentCallDetails(agent)"
                           (click)="onQueueAgentCallDetailClick($event, agent)"
                        >
                           @if (!isQueueAgentAvailable(agent)) {
                           <span class="queue-member-agent-pill-status">
                              {{ getQueueAgentsTabStatusLabel(agent) }}
                           </span>
                           } @if (isQueueAgentPhoneIconVisible(agent)) {
                           <mat-icon
                              class="queue-member-phone-icon"
                              [matTooltip]="getQueueAgentPhoneIconTooltip(agent)"
                           >
                              phone_in_talk
                           </mat-icon>
                           }
                        </span>
                        }
                     </ng-template>
                  </div>
               </ndt-tile-view>
            </div>
         </div>
         }
      </div>
   </div>
   } @if (displayMode === 'queue-calls' && hasVisibleQueueMembers) {
   <div class="queue-members-horizontal-scroll">
      <div class="queue-members-horizontal-track">
         @for (item of queueCallGridItems; track trackGridItem($index, item)) {
         <div class="queue-member-horizontal-lane" [attr.data-queue-call-lane-id]="item.id">
            <div
               class="queue-member-tile queue-member-tile-neutral queue-member-tile-lane"
               [attr.data-queue-calls-cache-key]="item.cacheKey"
            >
               <ndt-tile-view [tileConfig]="getQueueCallsTileConfig(item)" [canRefresh]="false">
                  <p tileheadername>
                     <a
                        class="queue-member-tile-header-link"
                        [routerLink]="getQueueExtensionLink(item.queue.queueExtensionId)"
                     >
                        {{ getQueueDisplay(item.queue.queueNumber, item.queue.queueName) }}
                     </a>
                  </p>

                  <div tileInfo class="queue-member-tile-body queue-member-tile-body-lane">
                     <div class="queue-member-tile-meta">
                        <span
                           class="queue-member-status-pill queue-member-stat-pill"
                           [matTooltip]="getQueueCallStatTooltip(getQueueCallsForQueue(item.queue.queueExtensionId))"
                           matTooltipClass="queue-member-stat-tooltip"
                        >
                           <mat-icon class="queue-member-stat-pill-icon">phone_in_talk</mat-icon>
                           <span>{{ getQueueCallStatLabel(getQueueCallsForQueue(item.queue.queueExtensionId)) }}</span>
                        </span>
                        <span
                           class="queue-member-status-pill queue-member-stat-pill"
                           [matTooltip]="getQueueAgentStatTooltip(item.queue.queueExtensionId)"
                           matTooltipClass="queue-member-stat-tooltip"
                        >
                           <mat-icon class="queue-member-stat-pill-icon">support_agent</mat-icon>
                           <span>{{ getQueueAgentStatLabel(item.queue.queueExtensionId) }}</span>
                        </span>
                     </div>

                     <div
                        class="queue-member-call-list queue-member-lane-scroll-region queue-member-agent-scroll-region"
                     >
                        @if (item.queue.activeCalls.length === 0) {
                        <div class="queue-member-call-list-empty">No queue calls to display</div>
                        } @for (queueCall of item.queue.activeCalls; track trackQueueCall($index, queueCall)) {
                        <div
                           class="queue-member-agent-pill queue-member-call-pill"
                           [ngClass]="getQueueCallVisualStateClass(queueCall) || 'queue-member-call-pill-neutral'"
                           [class.queue-member-call-pill-clickable]="canOpenCallDetails(queueCall)"
                           (click)="onQueueCallClick(queueCall)"
                        >
                           <span class="queue-member-agent-pill-copy">
                              <span class="queue-member-agent-pill-name">
                                 {{ getQueueCallNumberDisplay(queueCall) | formatPhoneNumbers }}
                              </span>
                              <span class="queue-member-agent-pill-secondary">
                                 {{ getQueueCallStatusLabel(queueCall) }}
                              </span>
                           </span>
                           <span class="queue-member-agent-pill-meta">
                              <span
                                 class="queue-member-agent-pill-status queue-member-call-pill-wait-time"
                                 [matTooltip]="getQueueCallDurationTooltipLabel(queueCall)"
                              >
                                 {{
                                    getQueueCallDurationStartDate(queueCall)
                                       | waitDuration : getQueueCallDurationEndDate(queueCall)
                                 }}
                              </span>
                           </span>
                        </div>
                        }
                     </div>
                  </div>
               </ndt-tile-view>
            </div>
         </div>
         }
      </div>
   </div>
   } @if (displayMode === 'agents' && groupMembersByQueue && hasVisibleQueueMembers) {
   <ktd-grid
      class="queue-members-grid-layout"
      [trackById]="trackGridLayoutItem"
      [cols]="queueMemberGridColumns"
      [gap]="queueMemberGridGap"
      [rowHeight]="groupedQueueMemberGridRowHeight"
      [layout]="groupedGridLayout"
   >
      @for (item of groupedGridItems; track trackGridItem($index, item)) {
      <ktd-grid-item
         [class.queue-member-grid-item]="item.kind === 'queue-agent'"
         [class.queue-banner-grid-item]="item.kind === 'queue-banner'"
         [id]="item.id"
         [draggable]="false"
         [resizable]="false"
      >
         @if (item.kind === 'queue-banner') {
         <div class="queue-members-group-banner">
            <a class="queue-members-group-link" [routerLink]="getQueueExtensionLink(item.queue.queueExtensionId)">
               {{ getQueueDisplay(item.queue.queueNumber, item.queue.queueName) }}
            </a>
            <span class="queue-members-group-count">{{ getQueueAgentCountLabel(item.queue.agents.length) }}</span>
         </div>
         } @else { @if (item.kind === 'queue-agent') {
         <div class="queue-member-tile" [ngClass]="getVisualStateClass(getQueueAgentVisualState(item.agent))">
            <ndt-tile-view [tileConfig]="getQueueAgentTileConfig(item)" [canRefresh]="false">
               <p tileheadername>
                  @if (item.agent.agentExtensionId != null) {
                  <a
                     class="queue-member-tile-header-link"
                     [routerLink]="getQueueExtensionLink(item.agent.agentExtensionId)"
                  >
                     {{ getAgentDisplay(item.agent.agentName, item.agent.agentNumber) }}
                  </a>
                  } @else {
                  {{ getAgentDisplay(item.agent.agentName, item.agent.agentNumber) }}
                  }
               </p>

               <div tileInfo class="queue-member-tile-body">
                  <div class="queue-member-tile-meta">
                     <span class="queue-member-status-pill">
                        {{ getQueueAgentStatusLabel(item.agent) }}
                     </span>
                     @if (isQueueAgentPhoneIconVisible(item.agent)) {
                     <span class="queue-member-phone-pill">
                        <mat-icon
                           class="queue-member-phone-icon"
                           [matTooltip]="getQueueAgentPhoneIconTooltip(item.agent)"
                        >
                           phone_in_talk
                        </mat-icon>
                     </span>
                     }
                  </div>
               </div>
            </ndt-tile-view>
         </div>
         } }
      </ktd-grid-item>
      }
   </ktd-grid>
   }
</div>
